import React, { useEffect, useMemo, useRef, useState } from 'react';
import Sentiment from './Sentiment';
import CardTrends from './CardTrends';
import { norms } from '../../constants/index';
import { Comments } from './Comments';
import KeywordColumn from '@/pages/opinion/components/KeywordColums';
import { getPublishingTimelineDataInfo } from '@/pages/opinion/services/accounts';
import { getRationPercentValue } from '@/pages/opinion/utils';
import BubbleCommon, {
  accountsChannelCardText,
  accountsTopTipsText,
} from '@/pages/opinion/components/BubbleCommon';
import useReviewModalData from '@/pages/opinion/components/ReviewsModal/useReviewModalData';
import ReviewsModal from '@/pages/opinion/components/ReviewsModal';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useIntl, useHistory } from 'umi';
import { goStatsDetailAction } from '../../../stats/Detail';
import { openWindowUrl } from '@/pages/opinion/utils/url';
import './index.scss';

// 这个页面的请求有点问题，后续需要调整
function AccountsCard({
  type,
  navigator,
  keepParams,
  channel = {},
  languageType,
  setNoDataMap,
  wholeGameInfo,
  gameInfo,
  jumpType,
}: any) {
  if (!navigator) return null;

  const [renderList, setRenderList] = useState(norms);
  const noDataMap = useRef({
    post: false,
    keyword: false,
    chart: false,
  });

  const [noData, setNoData] = useState(false);
  const [contentNoData, setContentNoData] = useState(false);
  const dataReBackNotice = (obj: { [key: string]: boolean }) => {
    noDataMap.current = Object.assign(noDataMap.current, obj);
    const flag = Object.values(noDataMap.current).every(Boolean);

    if (flag) {
      setNoData(true);
      setNoDataMap(true);
    } else {
      const { keyword, post } = noDataMap.current;
      setContentNoData(keyword && post);
    }
  };

  // 获取图表数据
  const getChartList = (otherInfo: any = {}) => {
    setNoData(false);
    setNoDataMap(false);
    const { channel, region, ...otherParams } = keepParams;
    const params = {
      ...otherParams,
      ...otherInfo,
      model_type: type,
      regions: region,
      metrics: norms.map((item) => item.params),
      need_total_link: true,
      sort_model: 'desc',
    };
    getPublishingTimelineDataInfo(params).then((data: any) => {
      const {
        timeline_of_end_time,
        timeline_of_start_time,
        list,
        link_of_end_time,
        link_of_start_time,
      } = data || {};

      const renderList = norms.map((item) => {
        const { timeline, total_new, total_old } = list?.[item.params] || {};
        return {
          ...item,
          timeline: timeline || [],
          total: total_new,
          total_old,
          timeline_of_end_time,
          timeline_of_start_time,
          total_ratio: getRationPercentValue(total_new || 0, total_old || 0),
          oldTime: [link_of_start_time, link_of_end_time],
          newTime: [params.start_time, params.end_time],
          flag: (timeline && timeline.length > 0) || !!total_new,
        };
      });
      dataReBackNotice?.({
        chart: !renderList.map((item) => item.flag).some(Boolean),
      });
      setRenderList([...renderList]);
    });
  };
  const { formatMessage } = useIntl();
  const [count, setCount] = useState(0);
  const subTitleTemplate = useMemo(() => {
    if (type === 'channel') {
      return (
        <span className="dbo-accountsbox-subtitle">
          {formatMessage({ id: 'Total Accounts' })}: {count}
          <BubbleCommon
            placement="top"
            tipsMap={accountsChannelCardText}
          ></BubbleCommon>
        </span>
      );
    }

    return (
      <span
        className={`dbo-accountsbox-subtitle ${
          navigator.account_url ? 'active' : ''
        }`}
        onClick={() => openWindowUrl(navigator.account_url)}
      >
        <img src={channel.img}></img>
        <BubbleCommon
          tipsMap={accountsTopTipsText(navigator.account)}
          showIcon={false}
        >
          {navigator.account}
        </BubbleCommon>
      </span>
    );
  }, [count, type, navigator, channel, formatMessage]);

  const getParams = (info: any) => {
    const { channels, ...othersParams } = keepParams;
    return {
      ...othersParams,
      ...info,
      review_types: ['posts_text', 'posts_video'],
    };
  };

  const [keywordParams, setKeywordParams] = useState({});
  const [localParams, setLocalParams] = useState({
    social_media_by_account: [],
  });
  const [loading, setLoading] = useState(false);

  // channel 获取所有的官号数量
  useEffect(() => {
    setLoading(true);
    setContentNoData(false);
    if (type === 'account') {
      const { accounts, channel_accounts, social_media_by_account, channels } =
        navigator;
      const params = getParams({
        social_media_by_account,
        channel: channels,
      });
      setLocalParams(params);
      setKeywordParams({
        ...params,
        keyword_top_n: 15,
        keyword_sample_size: '30',
      });
      getChartList({ channel_accounts, accounts, channels });
      setLoading(false);
    } else {
      const { total, social_media_by_account, channels, accounts } = navigator;
      setCount(total);
      const params = getParams({ social_media_by_account, channel: channels });
      setLocalParams(params);
      getChartList({ accounts, channels });
      setKeywordParams({
        ...params,
        keyword_top_n: 15,
        keyword_sample_size: '30',
      });
      setLoading(false);
    }
  }, [navigator]);

  const { reviewsVisible, data, openModal, toggleModal } = useReviewModalData();
  const [showMore, setShowMore] = useState(false);

  const history = useHistory();

  return (
    <CardCommon
      className="dbo-accountsbox"
      loading={loading}
      empty={noData}
      emptyHeight={300}
      title={
        <div className="dbo-accountsbox-title">
          <span>
            {navigator.noFormat
              ? navigator.name
              : formatMessage({ id: navigator.name })}
          </span>
          {subTitleTemplate}
        </div>
      }
    >
      <>
        <div
          className={`dbo-accountsbox-metrics ${showMore ? 'show-all' : ''}`}
        >
          {renderList?.map((item: any) => {
            return (
              <CardTrends
                key={item.text}
                keepParams={localParams}
                itemInfo={item}
                channel={channel}
              ></CardTrends>
            );
          })}
        </div>
        {renderList?.length > 6 ? (
          <span
            className="dbo-accountsbox-metrics-more"
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            {formatMessage({
              id: !showMore ? 'More Metrics' : 'Less Metrics',
            })}
          </span>
        ) : null}
        <CardCommon
          contentCard
          empty={contentNoData}
          emptyHeight={180}
          hasEmptyDesc={false}
          hasEmptyImg={false}
          emptyTitleText={formatMessage({ id: 'No data' })}
        >
          <>
            <Sentiment
              keepParams={localParams}
              type={type}
              channel={channel}
            ></Sentiment>
            <KeywordColumn
              noLoading
              dataReBackNotice={dataReBackNotice}
              params={keywordParams}
              className={'accounts-card-keywords'}
              language={languageType}
              noDateText={
                <span className="dbo-accounts-nodata">
                  {formatMessage({ id: 'No Keywords' })}
                </span>
              }
              tipsClass={'tips-info'}
              onClick={(keyword, children) => {
                goStatsDetailAction({
                  path: `/opinion/Stats/Detail${
                    gameInfo?.edition_unified_id
                      ? `?gameid=${gameInfo?.edition_unified_id}`
                      : ''
                  }`,
                  params: {
                    filter: {
                      ...localParams,
                      keyword: children,
                    },
                    statsDetailType: `accounts-${type}-keyword`,
                  },
                  history,
                  jumpType,
                });
              }}
            ></KeywordColumn>
            <Comments
              dataReBackNotice={dataReBackNotice}
              keepParams={localParams}
              type={type}
              languageType={languageType}
              itemClick={openModal}
              channel={channel}
              gameInfo={gameInfo}
              wholeGameInfo={wholeGameInfo}
            ></Comments>
          </>
        </CardCommon>

        <ReviewsModal
          visible={reviewsVisible}
          data={data}
          language={languageType}
          close={toggleModal}
          gameInfo={gameInfo}
        />
      </>
    </CardCommon>
  );
}

export default React.memo(AccountsCard);
